module.exports = __webpack_public_path__ + "assets/img/form2.2f8b3c63.png";